export class AddLinkForm {
    constructor(el) {
        this.el = el;
        this.items = el.querySelectorAll(".js-filter-item");
        this.linkInput = document.querySelector(".js-copy-link-input");
        this.inputId = document.querySelector(".js-set-test-id-select")?.querySelector(".js-input-select-value");
        this.initEvents();
    }

    initEvents() {
        this.el.addEventListener("formSuccess", (e) => {
            this.linkInput.value = e.detail.data.link;
            if (this.inputId) {
                const list = document.querySelector(`.js-list[data-id="${this.inputId.value}"]`);
                if (list) {
                    list.dispatchEvent(new CustomEvent("loadList"));
                }
            }
            document.dispatchEvent(new CustomEvent("refreshStatistic"));
        });
    }
}

document.querySelectorAll(".js-add-link-form").forEach(elem => new AddLinkForm(elem));
